import { z } from "zod";
import { operationResearchStateSchema } from "./operation.js";
import { workbookIssueSchema } from "./workbook.js";
export const problemCodeSchema = z.enum([
    "UNAUTHENTICATED",
    "PERMISSION_DENIED",
    "ENVIRONMENT_MISMATCH",
    "CONTEXT_MISMATCH",
    "IDEMPOTENCY_KEY_REUSED",
    "IDEMPOTENCY_IN_PROGRESS",
    "IDEMPOTENCY_LEASE_LOST",
    "NO_PUBLISHED_RULESET",
    "RULESET_STALE_BASE",
    "SEPARATION_OF_DUTIES_VIOLATION",
    "VERSION_PRECONDITION_FAILED",
    "BATCH_TOO_LARGE",
    "VALIDATION_FAILED",
    "RATE_LIMITED",
    "DEPENDENCY_UNAVAILABLE",
    "OPERATION_NOT_AVAILABLE",
    "OPERATION_PRICING_UNRESOLVED",
    "ARTIFACT_UNAVAILABLE",
    /** Another web research run holds the singleton (fresh heartbeat). */
    "RUN_ACTIVE",
    /** A unit lease expired or was taken over; the result was not recorded. */
    "LEASE_LOST",
    "NOT_FOUND",
    "INTERNAL_ERROR",
]);
export const problemDetailsSchema = z
    .object({
    type: z.string().url(),
    title: z.string().min(1),
    status: z.number().int().min(400).max(599),
    code: problemCodeSchema,
    detail: z.string().min(1),
    instance: z.string().min(1),
    requestId: z.string().min(1).optional(),
    correlationId: z.string().min(1).optional(),
    retryable: z.boolean(),
    /** Only the explicit operation-research opt-in returns this durable pending receipt. */
    research: operationResearchStateSchema.optional(),
    violations: z
        .array(z
        .object({
        field: z.string().min(1),
        message: z.string().min(1),
        /** Where and why, for a workbook problem: sheet, row, column and what was expected. */
        issue: workbookIssueSchema.optional(),
    })
        .strict())
        .default([]),
})
    .strict();
//# sourceMappingURL=problem.js.map